// enable docker
let isdocker 			= readDockerFlag();
let is_env		  		= false;

export function readBooleanBuildFlag(raw) {
	if (raw === undefined || raw === null || String(raw).trim() === '') {
		return false;
	}
	const s = String(raw).trim().toLowerCase();
	return s === 'true' || s === '1' || s === 'yes';
}

export function readRuntimeConfig() {
	if (typeof window === 'undefined') {
		return {};
	}
	return window.__ALICE_RUNTIME_CONFIG__ || window.__APP_CONFIG__ || {};
}

function readRuntimeBooleanFlag(name) {
	const raw = readRuntimeConfig()[name];
	if (raw === undefined || raw === null || String(raw).trim() === '') {
		return undefined;
	}
	return readBooleanBuildFlag(raw);
}

export function readDockerFlag() {
	const runtimeDocker = readRuntimeBooleanFlag('VUE_APP_DOCKER');
	if (runtimeDocker !== undefined) {
		return runtimeDocker;
	}
	const runtimeLegacyDocker = readRuntimeBooleanFlag('VUE_APP_IS_DOCKER');
	if (runtimeLegacyDocker !== undefined) {
		return runtimeLegacyDocker;
	}
	return readBooleanBuildFlag(process.env.VUE_APP_DOCKER) || readBooleanBuildFlag(process.env.VUE_APP_IS_DOCKER);
}

/** Rutas /hls y /webrtc (format_local_*) solo si es true. Build: VUE_APP_REVERSE_PROXY=true */
export function readReverseProxyFlag() {
	const runtimeReverseProxy = readRuntimeBooleanFlag('VUE_APP_REVERSE_PROXY');
	if (runtimeReverseProxy !== undefined) {
		return runtimeReverseProxy;
	}
	return readBooleanBuildFlag(process.env.VUE_APP_REVERSE_PROXY);
}
const reverse_proxy = readReverseProxyFlag();

// setting api
let port 				=  	`9090`, 
	port_socket 		= 	`4550`, 
	port_face 			= 	`8004`,
	ip 					= process.env.VUE_APP_HOST || (location.hostname == `.` || location.hostname == `chromewebdata`  ? 
							`localhost` :  
							location.hostname),//location.hostname),//location.hostname),// location.hostname),//`66.181.165.209`), //location.hostname),//   `66.181.165.209`), // '10.70.70.5'),
	ip_socket			= 	ip, 
	workspace  			= 	`workspace`,
	proto  				=   window.location.protocol,
	protocol  			= 	`${proto}//`,
	protocol_socket  	= 	`${proto}//`,
	ext   				= 	``,  //  for public local front
	base 				=   `/`, // for routes local front => `/app`
	domain 				=  window.location.host,
	workspace_domain	=  ip;

	// ip  =  `193.178.3.128`; // .140 //location.hostname;  //`193.178.3.128`; //`193.178.3.109`;  ; //
		// `190.60.120.136`  `10.70.70.17` // `10.70.70.17` // `10.70.70.17`//  `193.178.3.128`; //  `193.178.3.109`
		//"odt.guardian.site"//location.hostname; //location.hostname;//  location.hostname;//`10.70.70.6`; //local;  //
		//location.hostname; //location.hostname;//  location.hostname;//`10.70.70.6`; //local;  //
		//location.hostname+'/ws'; //`10.70.70.6`; //ip_socket;

	// socket = "odt.guardian.site"//location.hostname+'/ws'; //`10.70.70.6`; //ip_socket;
// console.log("location : ", window.location)
// set dockerenable_env
if(isdocker){
	let is_port 		= proto.includes("https") ? `443` : `80`;
	ip  				= location.hostname//`odt.guardian.site`;
	port  				= is_port;
	port_socket 		= is_port;
	ext  	    		= `/app`;
	workspace_domain   	= domain.split(".")[0];
	base 				= ext;

}

//  set its env = true default false
if (is_env) {
	
// console.log( " **************** PROCESS ENV : ", process.env.VUE_APP_PORT_API ) //|| "default"
// process.env.NODE_ENV  = modo de desalloro
// process.env.VUE_APP_PORT_API = port api
	if (process.env.NODE_ENV == `development`) {

		port 			= process.env.VUE_APP_PORT_API 		|| `9090`;
		port_socket 	= process.env.VUE_APP_PORT_SOCKET 	|| `4550`;
	}else{
		// console.log("process.env.NODE_ENV", process.env);
		port 			= process.env.VUE_APP_PORT_API 		|| `9090`;
		port_socket 	= process.env.VUE_APP_PORT_SOCKET	|| `4550`;
	}
	if (process.env.HOST_WEBSOCKET || process.env.VUE_APP_HOST_WEBSOCKET ) {
		ip_socket 	= process.env.HOST_WEBSOCKET || process.env.VUE_APP_HOST_WEBSOCKET;
	}

	if (process.env.HOST_BACKEND || process.env.VUE_APP_HOST_BACKEND) {
		ip 			= process.env.HOST_BACKEND || process.env.VUE_APP_HOST_BACKEND;
	}
} // is_env

let url  				= 	`${protocol + ip}:${port}`,
	url_face 			= 	`${protocol + ip}:${port_face}`,
	url_ext				=   url + ext;

const Api = {
	ip,
	ip_socket,
	port,
	port_socket,
	port_face,
	workspace,
	protocol,
	protocol_socket,
	url,
	url_face,
	url_ext,
	ext,
	isdocker,
	base,
	domain,
	workspace_domain,
	reverse_proxy,
	eventosPorId: {}
};
export default Api
